export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_7361_FOCUS': 'Focus',
    '_11130_COPY_MESSAGE': 'Copy Message',
    '_11131_DELETE_MESSAGE': 'Delete Message',
    '_11036_ENTER_YOUR_TEXT': 'Enter your text',
    '_11037_ADD_NOTES': 'Add Notes',
    '_11132_CREATE_COACHING_NOTES_FROM_CHAT_CONVERSATION': 'Create coaching notes from chat conversation',
    '_11133_REPLY': 'Reply',
    '_11134_SELECT_YOUR_EMOJI': 'Select your emoji',
    '_11135_CLOSE_WINDOW': 'Close window',
    '_11136_EXPAND_WINDOW': 'Expand Window',
    '_11137_COLLAPSE_WINDOW': 'Collapse Window',
    '_11139_CHAT_CAN_NOT_BE_CREATED': 'Chat can not be created',
    '_11140_AN_EMAIL_IS_UNREGISTERED_WITHIN_THE_MICROSOFT_TENANT': 'An email is unregistered within the Microsoft Tenant',
    '__CONNECTING_TO_MS_TEAMS': 'Connecting to MS Teams',
    '_11041_CHAT': 'Chat',
    '_637_OKAY': 'Okay',
    '__THERE_IS_ALREADY_A_CHAT_CREATED_FOR_THIS_COMMITMENT_': 'There is already a chat created for this commitment that you are not part of. To access the chat please ask one of the participants to add you via MS Teams'
};
